import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function TitleUpdater() {
    const location = useLocation();

    useEffect(() => {
        const routeTitles = {
            '/': 'JK Sugars',
            '/dashboard': 'Home',
            '/create-utility': 'U - Company Creation',
            '/create-company': 'Create Company',
            '/select-company': 'Select Company',
            '/create-accounting-year': 'Create Accounting Year',
            '/select-accounting-year': 'Select Accounting Year',
            '/AccountMaster-utility': 'U - Account Master',
            '/account-master': 'Account Master',
            '/financial-groups-utility': 'U - Financial Groups',
            '/financial-groups': 'Financial Groups',
            '/city-master-utility': "U - City Master",
            '/city-master': "City Master",
            '/syetem-masterutility': "U - System Master",
            '/syetem-master': "System Master",
            '/brand-master-utility': "U - Brand Master",
            '/brand-master': "Brand Master",
            '/gst-rate-masterutility': "U - GST Rate Master",
            '/gst-ratemaster': "GST Rate Master",
            '/gst-state-master-utility': "U - GST State Master",
            '/gst-state-master': "GST State Master",
            '/RecieptPaymentUtility': 'U - Receipt Payment',
            '/receipt-payment': 'Receipt Payment',
            '/JournalVoucher_Utility': "U - Journal Voucher",
            '/journal-voucher': "Journal Voucher",
            '/utrentry-Utility': "U - UTR Entry",
            '/utr-entry': "UTR Entry",
            '/debitcreditnote-utility': "U - Debit Credit Note",
            '/debitcreditnote': 'Debit Credit Note',
            '/other-purchaseutility': 'U - Other Purchase',
            '/other-purchase': 'Other Purchase',
            '/PaymentNote-utility': 'U - Payment Note',
            '/payment-note': 'Payment Note',
            '/tender-purchaseutility': "U - Tender Purchase",
            '/tender_head': "Tender Purchase",
            '/sauda-book-utility-page': "U - Sauda Book",
            '/sauda-book-utility': "Sauda Book",
            '/delivery-order-utility': "U - Delivery Order",
            '/delivery-order': "Delivery Order",
            '/SaleBill-utility': "U -Sale Bill",
            '/sale-bill': "Sale Bill",
            '/CommissionBill-utility': "U - Commission Bill",
            '/commission-bill': "Commission Bill",
            '/sugarpurchasebill-utility': "U - Sugar Purchase Bill",
            '/sugarpurchasebill': "Sugar Purchase Bill",
            '/company-list': 'Select Company',
            '/letter': 'U - Letter',
            '/letter-data': 'Letter',
            '/balance-stock': 'Balance Stock',
            '/millwise-stock': 'Mill Wise Lifting Wise',
            '/self-stock': 'Self Stock Book',
            '/profit-loss-balance-sheet': 'Profit Loss & Balance Sheet',
            '/ProfitLoss-Report': 'Profit & Loss',
            '/Balancesheet-Report': 'Balance Sheet',
            '/user-permission-utility': 'U - User Permission',
            '/user-creation': "User Creation",
            '/DispatchDetailsForMill': "Dispatch Details For Mill",
            '/sugar-sale-return-sale-utility': "U - Sugar Sale Return Sale",
            '/sugar-sale-return-sale': "Sugar Sale Return Sale",
            '/ledger': 'Ledger',
            '/ledger-report': 'Ledger Report',
            '/daybook': "Day Book",
            '/daybook-report': 'Day Book Report',
            '/multiple-ledger': 'Multiple Ledger',
            '/company-parameter': 'Company Parameters',
            '/whatsapp-api': "Whats App",
            '/OtherGSTInput-utility': 'U - Other GST Input',
            '/other-gst-input': 'Other GST Input',
            '/sugar-sale-return-purchase-utility': 'U - Sugar Sale Return Purchase',
            '/sugar-sale-return-purchase': 'Sugar Sale Return Purchase',
            '/Settletenders': 'Settle Tender',
            '/trial-balance': 'Trial Balance',
            '/ServiceBill-utility': 'U - Service Bill',
            '/service-bill': 'Service Bill',
            '/tenderwise-reports': 'Tender Wise Report',
            '/UTRReportSummary-reports': 'UTR Report Summary',
            '/MillPaymentSummary-reports': 'Mill Payment Summary',
            '/DuepaymentSummary-reports': 'Due Payment Summary',
            '/SaudaSummary-reports': 'Sauda Summary',
            '/normal-sauda-summary': 'Normal Sauda Summary',
            '/utr_detail-report': 'UTR Detail Report',
            '/purchase-sale-registers': 'Purchase Sale Register',
            '/Sale-registers': 'Sale Register',
            '/stock-book': 'Stock Book',
            '/companylogs': 'Company Edit Logs',
            '/ewaybill': 'eWay Bill & eInvoice',
            '/periodic-sale-report': 'Daily Sale',
            '/periodic-sale-report-bar-chart': 'Monthly Sale',
            '/send-message': 'BroadCast Messages',
            '/live-tenders': 'Live eTenders',
            '/TrialBalancescreen': 'Trail Balance Screen',
            '/genratesalary': 'Salary Posting',
            '/live-alltenders': 'Daily Purchase',
        };

        document.title = routeTitles[location.pathname] || 'JK Sugars';
    }, [location.pathname]);

    return null;
}

export default TitleUpdater;